import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
const DefaultHandle = ({ handle, className }) => {
  return /* @__PURE__ */ jsxs(
    "g",
    {
      className: classNames(
        "tl-handle",
        { "tl-handle__hint": handle.type !== "vertex" },
        className
      ),
      children: [
        /* @__PURE__ */ jsx("circle", { className: "tl-handle__bg" }),
        /* @__PURE__ */ jsx("circle", { className: "tl-handle__fg" })
      ]
    }
  );
};
export {
  DefaultHandle
};
//# sourceMappingURL=DefaultHandle.mjs.map
